/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useParams, useHistory } from 'react-router';
import { createUrlToActualResource } from './resource-url-builder';
import { useCrmHostUrlContext } from './crm-host-url-context';
import { useAllowedActions } from '../../authentication/use-allowed-actions';
import { ResourceTypes, ResourceOperations } from '../../authentication/resources';
import { useRoleThemes } from '../../authentication/use-role-themes';
import { citizenDetailsTabPathName } from '../../areas/citizen/authority/citizen-authority-area-pathnames';
import { medicalCollaborationTabPathName } from '../../areas/citizen/serviceprovider/citizen-serviceprovider-area-pathnames';
import { win } from '../../utilities';

export function ResourceRedirect() {
  const { url: crmHostUrl } = useCrmHostUrlContext();
  const { resourceName } = useParams<{ resourceName: string }>();
  const searchParams = new URLSearchParams(win.location.search);
  const resourceId = searchParams.get('resourceId');
  const rootEntityId = searchParams.get('rootEntityId') || undefined;
  const history = useHistory();

  const hasSocialProviderCitizenRead = useAllowedActions().isAnyAllowed([{ resourceType: ResourceTypes.SocialProviderCitizen, resourceOperation: ResourceOperations.Read }]);
  const socialProviderCitizenLandingTab = hasSocialProviderCitizenRead ? citizenDetailsTabPathName : medicalCollaborationTabPathName;
  const { isOnlyServiceProvider, isOnlyMedicalCollaborator, rolesLoaded } = useRoleThemes();

  let redirectUrl = '/notfound';

  useEffect(() => {
    async function redirectWithRoutePush() {
      if (resourceId && crmHostUrl && rolesLoaded) {
        // we dont currently support resource urls without IDs. Change this code when/if we need to support that.
        const createdResourceUrl = await createUrlToActualResource(
          resourceName,
          resourceId,
          '',
          searchParams,
          rootEntityId,
          socialProviderCitizenLandingTab,
          isOnlyServiceProvider,
          isOnlyMedicalCollaborator
        );

        if (createdResourceUrl !== null) {
          redirectUrl = createdResourceUrl;
        }
        if (redirectUrl.startsWith(crmHostUrl)) {
          win.location.assign(redirectUrl);
        } else {
          history.push(redirectUrl.startsWith('/') ? redirectUrl : `/${redirectUrl}`);
        }
      }
    }
    redirectWithRoutePush();
  }, [resourceId, crmHostUrl, rolesLoaded, isOnlyServiceProvider, isOnlyMedicalCollaborator]);

  return null;
}
